var $0b39b205118db415$exports = {};
$0b39b205118db415$exports = {
    "breadcrumbs": `Breadcrumbs`
};


export {$0b39b205118db415$exports as default};
//# sourceMappingURL=en-US.module.js.map
